import {Component, OnDestroy, OnInit} from '@angular/core';
import {MesswertPaket} from '../../../model/messwerte/messwert-paket';
import {MatSnackBar} from '@angular/material/snack-bar';
import {FirebaseService} from '../../../service/firebase/firebase.service';
import {DatastoreService} from '../../../service/datastore/datastore.service';
import {map, take} from 'rxjs/operators';
import {Subscription} from 'rxjs';
import {SearchFilterService} from '../../../service/search/search-filter.service';
import {BundeslandFilterService} from '../../../service/bundeslandFilter/bundesland-filter.service';
import {ActiveMesswertTableFilter} from '../../../model/component/messwert-table-filter';

@Component({
  selector: 'app-messwert',
  templateUrl: './messwert.component.html'
})
export class MesswertComponent implements OnInit, OnDestroy {

  isLoading = false;
  messwertPakete: MesswertPaket[] = [];

  private subscription$: Subscription;

  private selectedQuelle = 'DWD';
  private selectedRegion = 'DEUTSCHLAND';
  private streetFilterActive = false;
  private showValuesOlderThanOneHour = true;

  constructor(public datastoreService: DatastoreService,
              private searchFilterService: SearchFilterService,
              private bundeslandFilterService: BundeslandFilterService,
              private firebaseService: FirebaseService,
              private snackBar: MatSnackBar) {
  }

  ngOnInit() {
    this.loadMesswertDaten();
    this.bundeslandFilterService.onFilterUpdated.subscribe(laender => {
      this.loadMesswertDaten();
    });
  }

  ngOnDestroy() {
    if (this.subscription$ !== undefined) {
      this.subscription$.unsubscribe();
    }
  }

  private loadMesswertDaten(): void {
    console.log(`Lade Daten ${this.selectedQuelle}_${this.selectedRegion}`);
    this.isLoading = true;
    this.subscription$ = this.firebaseService
      .getMesswertStuendlich(`${this.selectedQuelle}_${this.selectedRegion}`,
        this.bundeslandFilterService.getSelectedBundeslaenderNamesWithSimpleNameForBremen(), this.streetFilterActive)
      .pipe(take(1), map(messwertPakete => this.datastoreService.saveMesswertPakete(messwertPakete)))
      .subscribe(messwertPakete => {
        // console.log('messwertpakete', messwertPakete);
        this.filterMesswerte();
        this.snackBar.open('Daten erfolgreich geladen', 'OK');
        this.isLoading = false;
      }, error => {
        this.snackBar.open(`Messwerte konnten nicht abgeholt werden ${error}`, 'OK');
        this.isLoading = false;
      });
  }

  public refreshData() {
    if (this.selectedQuelle !== undefined && this.selectedRegion !== undefined) {
      this.loadMesswertDaten();
    }
  }

  public reloadDataWithNewFilter(activeFilter: ActiveMesswertTableFilter) {
    this.selectedQuelle = activeFilter.quellen;
    this.selectedRegion = activeFilter.region;
    this.streetFilterActive = activeFilter.hasStreetFilterActive;
    this.showValuesOlderThanOneHour = activeFilter.showValuesOlderThanOneHour;
    // console.log('RELOAD Messwerte');
    this.loadMesswertDaten();
  }

  private filterMesswerte() {
    this.messwertPakete = this.datastoreService.messwertList;
    if (!this.showValuesOlderThanOneHour) {
      // console.log('Filter max eine Stunde alte');
      let date = new Date();
      date.setHours(date.getHours() - 1);
      this.messwertPakete = this.datastoreService.messwertList.filter(messwert => messwert?.messwerte?.lufttemperatur?.messzeitpunkt.toDate() >= date);
    }
  }
}
